<template>
  <div class="main-container account-page align-items-stretch">
    <div class="site-contents my-account-payment d-flex align-items-top flex-wrap">
      <div class="container-fluid custom-container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-12">
            <div class="sidebar-account">
              <div class="account-payment">
                <ul>
                  <li>
                    <a
                      class="menu"
                      v-bind:class="{ 'active': accountDetail === true }"
                      @click="enableAccountDetail"
                    >Account Details</a>
                  </li>
                  <li>
                    <a
                      class="menu"
                      ref="paymentOption"
                      v-bind:class="{ 'active': paymentOptions === true }"
                      @click="enablePaymentOptions"
                    >Payment Options</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-lg-8 col-md-6 col-sm-12">
            <div v-show="accountDetail === true" class="account-payment-detail account-form">
              <h3>Account details</h3>
              <div
                class="alert alert-primary alert-dismissible"
                role="alert"
                v-if="showSuccessAlertMessage"
              >
                {{apiSuccessMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showSuccessAlertMessage=!showSuccessAlertMessage"
                />
              </div>
              <div
                class="alert alert-danger alert-dismissible"
                role="alert"
                v-if="showAlertMessage"
              >
                {{apiErrorMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showAlertMessage=!showAlertMessage"
                />
              </div>
              <div class="payment-option d-flex flex-wrap align-items-center">
                <div class="wrap-top">
                  <div class="user-account-img">
                    <img :src="profileImage" v-if="profileImage" class="profile-image" />
                    <img src="../../../public/assets/images/defaultUser.png" v-else />
                  </div>

                  <input type="file" ref="file" style="display:none" @change="changeProfilePic" />
                  <a href="#" @click="$refs.file.click()">Change profile image</a>
                </div>
                <div class="account-details">
                  <form @submit="updateUserProfile">
                    <div class="form-group">
                      <label for="full-name">Full Name</label>
                      <input
                        type="text"
                        class="form-control"
                        id="fullname"
                        name="fullName"
                        v-model="fullName"
                        @change="userDetails.name"
                        data-vv-as="Full Name"
                        v-validate="'required|min:2|max:500|nameFormat'"
                        v-bind:class="{ 'is-invalid': errors.has('fullName')}"
                        aria-describedby="fullname"
                      />
                      <a href="javascript:document.getElementById('fullname').focus()" class="edit">
                        <img src="assets/images/edit.svg" />
                      </a>
                      <span class="invalid-feedback">{{ errors.first('fullName') }}</span>
                    </div>
                    <div class="form-group">
                      <label for="email">Email</label>
                      <!-- <span>{{email}}</span> -->
                      <input
                        type="email"
                        class="form-control"
                        id="email"
                        @change="userDetails.email"
                        name="email"
                        v-model="email"
                        aria-describedby="email"
                        readonly
                      />
                    </div>
                    <div class="form-group pwd">
                      <label for="password">Password</label>
                      <router-link href="#" to="/changePassword">Reset Password</router-link>
                    </div>
                    <div class="form-group link-fb" v-if="userDetails.isFacebookLinked === false">
                      <label for="password">Link facebook</label>
                      <a
                        href="#"
                        class="btn btn-fb"
                        @click="linkFacebook"
                        :disabled="fbButtonDisable === true"
                      >{{fbButtonText}}</a>
                    </div>
                    <div v-else>
                      <a @click="disconnectFb">Disconnect facebook</a>
                    </div>
                    <br />
                    <div
                      v-if="(showSpinner === true)"
                      class="spinner-border"
                      style="width: 3rem; height: 3rem;color:#FD3E75;"
                      role="status"
                    ></div>
                    <button
                      type="submit"
                      class="btn btn-primary"
                      :disabled="disabled === true"
                    >{{buttonText}}</button>
                  </form>
                </div>
              </div>
            </div>
            <div v-show="accountDetail === false" class="account-payment-detail">
              <h3>Payment options</h3>

              <div
                v-if="showSpinner == true"
                class="spinner-border spinner-middle"
                style="width: 3rem; height: 3rem;color:#FD3E75;"
                role="status"
              ></div>
              <div v-else class="payment-method-list">
                <div
                  class="alert alert-success alert-dismissible"
                  :show="dismissCountDown"
                  dismissible
                  variant="success"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                  v-if="apiSuccessMessage!=null"
                >
                  {{apiSuccessMessage}}
                  <img
                    class="close"
                    src="assets/images/close.svg"
                    data-dismiss="alert"
                    aria-label="close"
                    @click="showSuccessAlertMessage=!showSuccessAlertMessage"
                  />
                </div>
                <div
                  class="alert alert-danger alert-dismissible"
                  :show="dismissCountDown"
                  dismissible
                  variant="danger"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                  v-if="apiErrorMessage!=null"
                >
                  {{ apiErrorMessage }}
                  <img
                    class="close"
                    src="assets/images/close.svg"
                    data-dismiss="alert"
                    aria-label="close"
                    @click="showSuccessAlertMessage=!showSuccessAlertMessage"
                  />
                </div>
                <div
                  v-for="(paymentMethod,index) in listPaymentMethods"
                  v-bind:key="paymentMethod.id"
                  class="payment-option d-flex flex-wrap align-items-center"
                >
                  <div class="vendor-logo">
                    <img v-if="paymentMethod.card.brand == 'visa'" src="assets/images/visa.png" />
                    <img
                      v-if="paymentMethod.card.brand == 'mastercard'"
                      src="assets/images/mastercard.png"
                    />
                    <img v-if="paymentMethod.card.brand == 'amex'" src="assets/images/amex.svg" />
                    <img
                      v-if="paymentMethod.card.brand == 'discover'"
                      src="assets/images/discover.png"
                    />
                  </div>
                  <div class="card-numb">
                    <p>
                      <strong>{{ paymentMethod.card.brand }}</strong>
                      ****{{paymentMethod.card.last4}}
                    </p>
                    <span>Expires on {{paymentMethod.card.exp_month}}/{{paymentMethod.card.exp_year}}</span>
                  </div>
                  <div class="actions">
                    <input
                      type="radio"
                      :checked="checked"
                      name="defaultPaymentMethod"
                      v-model="defaultPaymentMethod"
                      :value="paymentMethod.id"
                      @change="markAsDefault(paymentMethod.id)"
                    /> Mark as default
                    <a
                      class="delete"
                      @click="deletePaymentMethod(paymentMethod.id)"
                    >Delete</a>
                  </div>
                </div>
              </div>
              <!-- <a href="#">Edit payment methods</a> -->
              <button
                v-show="showAddButton === true"
                data-toggle="modal"
                data-backdrop="static"
                ref="addNewCard"
                data-keyboard="false"
                data-target="#addCard"
                class="btn btn-primary"
                @click="addNewCard = true"
              >Add payment method</button>
            </div>
          </div>
          <!--Modal start -->
          <div
            class="modal more-guest-list"
            id="cropImageModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cropImageModal"
            aria-hidden="true"
            :show="initialiseCropper()"
            ref="cropImageModal"
            v-if="accountDetail"
          >
            <div class="modal-dialog model-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h3 class="modal-title">Crop Image</h3>
                  <img
                    class="close"
                    src="../../../public/assets/images/close.svg"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  />
                </div>
                <div class="modal-body">
                  <vue-croppie
                    ref="croppieRef"
                    :enableOrientation="true"
                    :enforceBoundary="true"
                    :enableResize="true"
                    @result="result"
                    @update="update"
                    :enableExif="true"
                    :mouseWheelZoom="false"
                    :showZoomer="true"
                    :viewport="{ width: 322, height: 215, type: 'circle' }"
                    :boundry="{ width: 600, height: 430}"
                  ></vue-croppie>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    v-if="imagePreview && !profileImage"
                    class="btn btn-primary crop-button"
                    @click="crop()"
                  >Crop</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal end -->
          <!-- add card modal -->
          <div
            class="modal fade"
            id="addCard"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content payment-form">
                <img
                  class="close"
                  src="../../../public/assets/images/close.svg"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="closeAddNewCardModal()"
                />
                <h3>Add New Card</h3>

                <div class="modal-body">
                  <stripe-elements v-if="addNewCard" v-on:paymentMethodAdded="paymentMethodAdded()"></stripe-elements>
                </div>
              </div>
            </div>
          </div>
          <!-- end card modal -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually
import {
  UPDATE_USER_PROFILE,
  SAVE_UPDATED_PROFILE_IMAGE,
  UNLINK_FACEBOOK
} from "../../store/user/action.type";
import {
  CHANGE_USER_EDITED_VALUE,
  SIGN_UP_WITH_FACEBOOK
} from "../../store/auth/action.type";
import {
  LIST_PAYMENT_METHODS,
  DELETE_PAYMENT_METHOD,
  MARK_AS_DEFAULT
} from "../../store/payment/action.type";
import { SET_DEFAULT_PAYMENT_METHOD } from "../../store/payment/mutation.type";

import "../../plugins/fb-sdk";
import StripeElements from "./../payment/StripeElements";

Vue.use(VueCroppie);
export default {
  data() {
    return {
      fullName: "",
      email: "",
      profileImage: null,
      file: "",
      // imagePreview: "../assets/images/detail.png",
      imagePreview: null,
      showPreview: false,
      apiSuccessMessage: null,
      disabled: false,
      buttonText: "Update",
      showSpinner: false,
      showSuccessAlertMessage: false,
      showAlertMessage: false,
      apiErrorMessage: null,
      dismissSecs: 5,
      dismissCountDown: 0,
      checked: false,
      page: null,
      addNewCard: false,
      disabled: false,
      buttonText: "Update",
      showAddButton: true,
      fbButtonDisable: false,
      fbButtonText: "Link Facebook",

      //tabs
      accountDetail: true,
      listPaymentMethods: null,
      paymentOptions: false,
      width: "",
      height: ""
    };
  },
  components: {
    "stripe-elements": StripeElements
  },
  computed: {
    ...mapState({
      userDetails: state => state.auth.userDetails,
      defaultPaymentMethod: state => state.payment.defaultPaymentMethod
    })
  },  
  created() {    
    // console.log('user detail',this.userDetails.name)
    this.profileImage = this.userDetails.profileImage;
    this.fullName = this.userDetails.name;
    this.email = this.userDetails.email;
    this.page = this.$route.query.page;
   
    //if payement option page
    if (this.page == "payment-option") {
      this.accountDetail = false;
      this.enablePaymentOptions();
    }
    else{
      this.accountDetail = true;
      this.$validator.extend("nameFormat", {
          getMessage: field =>
            `${field} must not contain special character or numbers`,
          validate: value => value.match(/^[a-zA-Z_ ]*$/) !== null
      });
    }
  },
  mounted() {    
      
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    refresh() {
      this.$refs.croppieRef.destroy();
    },
    initCroppie() {
      this.$refs.croppieRef.initCroppie();
    },
    result(output) {
      this.profileImage = output;
    },
    update(val) {
      // console.log(val);
    },
    initialiseCropper() {
      if (this.$refs.croppieRef) {
        this.$refs.croppieRef.bind({
          url: this.imagePreview
        });
      }
    },

    changeProfilePic() {
      this.refresh();
      this.initCroppie();
      this.profileImage = null;
      this.file = this.$refs.file.files[0];

      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;
          this.$refs.file.value = "";
          $("#cropImageModal").modal("show");
        }.bind(this),
        false
      );
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    crop() {
      let options = {
        format: "jpeg",
        circle: true
      };

      this.$refs.croppieRef.result(options, output => {
        this.profileImage = output;
        // this.showSpinner = true;
      });
      $("#cropImageModal").modal("hide");
    },
    updateUserProfile(e) {
      e.preventDefault();
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.disabled = true;
          this.buttonText = "Updating";
          this.showSpinner = true;
          if (this.profileImage != this.userDetails.profileImage) {
            this.uploadProfileImage();
          } else {
            this.saveUpdatedUserProfile();
          }
        }
      });
    },

    uploadProfileImage() {
      let uploadedImage = {
        image: this.profileImage
      };
      if (this.profileImage) {
        this.$store
          .dispatch(SAVE_UPDATED_PROFILE_IMAGE, uploadedImage)
          .then(response => {
            if (response.status == 200) {
              this.profileImage = response.data.data.file;
            } else {
              this.disabled = false;
              this.buttonText = "Update";
              this.showAlertMessage = true;
              this.apiErrorMessage = response.data.message;
            }
            this.saveUpdatedUserProfile();
          })
          .catch(error => {
            this.showAlertMessage = true;
            this.apiErrorMessage = error.response.data.message;
          });
      }
    },

    saveUpdatedUserProfile() {
      let updatedDetails = {
        name: this.fullName,
        // email : this.email,
        profileImage: this.profileImage
      };
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store
            .dispatch(UPDATE_USER_PROFILE, updatedDetails)
            .then(response => {
              this.disabled = false;
              this.buttonText = "Update";
              if (response.status == 200) {
                this.$store.dispatch(CHANGE_USER_EDITED_VALUE, updatedDetails);
                this.showSuccessAlertMessage = true;
                this.apiSuccessMessage = response.data.message;
              } else {
                this.showAlertMessage = true;
                this.apiErrorMessage = response.data.message;
              }
              this.showSpinner = false;
            })
            .catch(error => {
              this.disabled = false;
              this.buttonText = "Update";
              this.showSpinner = false;
              this.showAlertMessage = true;
              this.apiErrorMessage = error.response.data.message;
            });
        }
      });
    },

    disconnectFb() {
      this.$store
        .dispatch(UNLINK_FACEBOOK, "")
        .then(response => {
          if (response.status == 200) {
            this.showSuccessAlertMessage = true;
            this.apiSuccessMessage = response.data.message;
          } else {
            this.showAlertMessage = true;
            this.apiErrorMessage = response.data.message;
          }
        })
        .catch(error => {
          this.showAlertMessage = true;
          this.apiErrorMessage = error.response.data.message;
        });
    },
    closeModal() {
      this.profileImage = this.userDetails.profileImage;
    },

    linkFacebook(e) {
      e.preventDefault();
      let self = this;
      setTimeout(() => {
         self.fbButtonDisable = true;
      }, 2000);
      // self.fbButtonText = "Please wait...";
      FB.login(function(response) {
        if (response.authResponse) {
          self.$store
            .dispatch(UNLINK_FACEBOOK, response.authResponse.accessToken)
            .then(response => {
              if (response.status == 200) {
                self.apiSuccessMessage = response.data.message;
                self.showSuccessAlertMessage = true;
              } else {
                self.apiErrorMessage = response.data.message;
                self.showAlertMessage = true;
              }
              self.fbButtonDisable = false;
              self.fbButtonText = "Link Facebook";
            })
            .catch(error => {
              self.fbButtonDisable = false;
              self.fbButtonText = "Link Facebook";
              self.apiErrorMessage = error.response.data.message || error;
              self.showAlertMessage = true;
            });
          // console.log("Welcome!  Fetching your information.... ");
          FB.api("/me", function(response) {
            // console.log("Good to see you, " + response.name + ".");
          });
        } else {
          self.fbButtonDisable = false;
          self.fbButtonText = "Link Facebook";
          // console.log("User cancelled login or did not fully authorize.");
        }
      });
    },

    //toggle menus
    enableAccountDetail() {
      this.apiErrorMessage = null;
      this.apiSuccessMessage = null;
      this.showSuccessAlertMessage = false;
      this.showAlertMessage = false;
      this.accountDetail = true;
      this.paymentOptions = false;
    },
    enablePaymentOptions() {
      this.apiErrorMessage = null;
      this.apiSuccessMessage = null;
      this.showSpinner = true;
      this.accountDetail = false;
      this.paymentOptions = true;
      this.showAddButton = true;
      let self = this;

      //list payment methods
      this.$store
        .dispatch(LIST_PAYMENT_METHODS)
        .then(response => {
          if (response.status == 200) {
            //set values
            this.$store.commit(
              SET_DEFAULT_PAYMENT_METHOD,
              response.data.data.defaultPaymentMethod
            );
            this.listPaymentMethods = response.data.data.paymentMethods;
          } else {
            this.showAlertMessage = true;
            this.apiErrorMessage = response.data.data.message;
          }
          this.showAddButton = true;
          this.showSpinner = false;
        })
        .catch(error => {
          this.showAlertMessage = true;
          this.showAddButton = true;
          //if card not found
          // if (!this.listPaymentMethods) {
          //   this.$refs.addNewCard.click();
          // }
          if (error.response) {
            this.apiErrorMessage = error.response.data.message;
          } else {
            this.apiErrorMessage =
              "Error processing payment. Please try again.";
          }
          this.showSpinner = false;
        });

        this.showSpinner = false;
    },
    //make default payment method
    markAsDefault(paymentMethod) {
      this.apiErrorMessage = null;
      this.apiSuccessMessage = null;
      this.showSpinner = true;
      let body = {
        paymentMethod
      };
      this.$store
        .dispatch(MARK_AS_DEFAULT, body)
        .then(response => {
          if (response.status == 200) {
            //set values
            this.$store
              .commit(
                SET_DEFAULT_PAYMENT_METHOD,
                response.data.data.defaultPaymentMethod
              )
              .then(function() {
                this.listPaymentMethods = response.data.data.paymentMethods;
              });

            this.showSuccessAlertMessage = true;
            this.apiSuccessMessage = response.data.data.message;
            this.apiErrorMessage = null;
            this.showSpinner = false;
          } else {
            this.showAlertMessage = true;
            this.apiErrorMessage = response.data.message;
            this.showSpinner = false;
          }
          this.showAlert();
        })
        .catch(error => {
          this.showSpinner = false;
          this.showAlertMessage = true;
          this.apiErrorMessage = error.response.data.message;
          this.showAlert();
        });
    },
    //detatch payment method from a customer
    deletePaymentMethod(paymentMethod) {
      this.apiErrorMessage = null;
      this.apiSuccessMessage = null;
      this.showSpinner = true;
      let body = {
        paymentMethod
      };
      this.$store
        .dispatch(DELETE_PAYMENT_METHOD, body)
        .then(response => {
          if (response.status == 200) {
            //set values
            this.$store.commit(
              SET_DEFAULT_PAYMENT_METHOD,
              response.data.data.defaultPaymentMethod
            );
            this.listPaymentMethods = response.data.data.paymentMethods;

            this.showSuccessAlertMessage = true;
            this.apiSuccessMessage = response.data.message;
            this.apiErrorMessage = null;
            this.showSpinner = false;
            this.showAlert();
          } else {
            this.showAlertMessage = true;
            this.apiErrorMessage = response.data.message;
            this.showSpinner = false;
          }
        })
        .catch(error => {
          this.showSpinner = false;
          this.showAlertMessage = true;
          this.apiErrorMessage = error.response.data.message;
          this.showAlert();
        });
    },
    //refresh list on new card addition
    closeAddNewCardModal() {
      this.showSpinner = true;
      this.apiSuccessMessage = null;
      this.apiErrorMessage = null;
      this.enablePaymentOptions();
      this.$refs.paymentOption.click();
    },
    paymentMethodAdded() {
      $("#addCard").modal("hide");
      this.closeAddNewCardModal();
      this.apiSuccessMessage = "Payment Method added successfully.";
    }
  },
  watch: {
    // showAlertMessage(newData) {
    //   if (newData) {
    //     var self = this;
    //     setTimeout(function() {
    //       self.showAlertMessage = false;
    //     }, 2000);
    //   }
    // },
    // showSuccessAlertMessage(newData) {
    //   if (newData) {
    //     var self = this;
    //     setTimeout(function() {
    //       self.showSuccessAlertMessage = false;
    //     }, 2000);
    //   }
    // }
  }
};
</script>

<style>
.form-control:disabled,
.form-control[readonly] {
  background-color: #f9f3ff;
  opacity: 1;
}

.link-fb .btn-fb {
  background-color: #4267b2;
  border: 0.0625rem solid #4267b2;
  color: #fff;
  font-weight: 500;
  width: 100%;
}

.btn-fb:hover {
  background-color: transparent;
  border-color: #4267b2;
  color: #4267b2;
}

/* .btn-fb:before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 24px;
  height: 24px;
  background: url(/img/fb-icon.e9773c08.svg);
  z-index: 999;
  left: 15%;
  top: 14px;
} */
.account-payment-detail .btn {
  padding: 0px 12px 0px 12px;
  margin-top: 10px;
}
a.delete {
  color: #fd3e75 !important;
  padding: 10px 0px 10px 16px;
  cursor: pointer;
}

@media (min-width: 768px) {
  .actions {
    margin-left: 10%;
  }
}
@media (max-width: 991px) {
  .actions {
    margin-left: 90px;
    width: 100%;
    margin-top: 30px;
  }
}
@media (max-width: 767px) {
  .actions {
    margin-left: 55px;
  }
}
.spinner-middle + .payment-method-list {
  opacity: 0.5;
}
.card-numb {
  min-width: 20%;
}
.account-payment-detail {
  min-height: 400px;
}
.vendor-logo img {
  width: 65px;
}
</style>